export default __webpack_public_path__ + "80e336f3b2d74c82ce4b7cd81350af71.png";